import React, { Component, createRef } from 'react'
import './GameBoardActivities/underCoverPuzzle.css';
import { getElementDimensions } from "../../objects/CommonUse/get_element_dimensions";
import Button from 'react-bootstrap/Button';
import UnderCoverPuzzleCard from './undercover_puzzle_card';
import UnderCoverRadioButtons from './undercover_puzzle_radio_buttons';
import calcRandomNumberWithMax from '../../objects/CommonUse/calc_random_number_with_max';
import { determineFriendComment } from './objects/determine_friend_comment';
import { displayFriendComment } from './objects/display_friend_comment';

class UnderCoverPuzzleModal extends Component {
  constructor(props){
    super(props);
    this.imageRef = createRef(); // make sure this is here!
    this.state={
        seconds:0,
        pictureDir: "./assets/Activities/Vacation/",
        finished: false,
        callRender: false,
        rerender: false,
        totalWidth: 0,
        totalHeight: 0,
    }
    this.invisibleArr = [];
    this.nbrColumns = 6;
    this.nbrRows = 5;
    this.indexArr = [];
    this.blankOutAllArr = [];
    this.imageArr = this.props.imageList;
    this.nbrPictures = 0;
    this.score = this.props.score;
    this.commentNbr = 0;
    this.arrayCreated = false;
    this.displayRadioButtons = false;
    this.startButton = true;
    this.displayFriend = false;
    this.correctAnswer = "";
  }
  
  preProcess(){
     this.createArray();
     this.selectPicture();
     this.startButton = true;
     this.displayFriend = false;
  }
  
 createArray(){
    this.indexArr = [];
    this.invisibleArr = [];
    this.displayRadioButtons = false;
    this.nbrInArray = this.nbrColumns * this.nbrRows;
    for (let i=0; i<this.nbrInArray; i++){
          this.indexArr.push(i);
    }
    this.blankOutAllArr = JSON.parse(JSON.stringify(this.indexArr));
    this.arrayCreated = true; 
    this.message = "Click Start to Uncover the answer."
    this.message2 = "";
    this.pictureFound = "";
    this.message3 = "";
  }

  selectPicture(){
      this.newPictureArr = [];
      this.correctAnswer = "";
      this.nbrPictures = this.props.score.nbrAttempted;
      for (let i=0; i<this.imageArr.length; i++){
           if (this.imageArr[i].selected === false){
                this.newPictureArr.push(this.imageArr[i]);
           }else{
                this.nbrPictures += 1;
           }
      }
      if (this.newPictureArr.length === 0){
          this.onClose();
      }else{
          let maxIndex = this.newPictureArr.length - 1;
          this.pictureIndx = calcRandomNumberWithMax(maxIndex);
          this.answer = this.newPictureArr[this.pictureIndx].answer;
          this.label = this.newPictureArr[this.pictureIndx].label;
          if (!this.newPictureArr[this.pictureIndx].pictureName){
             this.pictureName = this.label
          }else{
             this.pictureName = this.newPictureArr[this.pictureIndx].pictureName;
          } 
          this.backgroundURL = this.state.pictureDir + this.newPictureArr[this.pictureIndx].imageSrc;
      }
   }

  onStart=()=>{
    this.displayRadioButtons = true;
    this.displayFriend = false;
    if (this._isMounted === true){
        this.setState({seconds:this.state.seconds+1});
    }
    this.displayRadioButtons = true;
    this.createInvisibleEntry();
    
 }

 createInvisibleEntry=()=>{
     if (this.indexArr.length > 0){
        let maxIndex = this.indexArr.length - 1;
        let indx = calcRandomNumberWithMax(maxIndex);
        let invisibleIndx = this.indexArr[indx];
        this.invisibleArr.push(invisibleIndx);
        this.indexArr.splice(indx,1);
    }else{
        this.onChangeValue("timeout");
    }
 }

 timer=()=>{
    this.f=setInterval(this.onStart,500);
    document.getElementById('btn').disabled=true;
 }

 onPause=()=>{
     clearInterval(this.f);
     this.startButton = false;
     document.getElementById('btn').disabled=false;
 }

  onChangeValue(slctAnswer) {
      if (slctAnswer === this.answer  || slctAnswer === "timeout"){
          this.displayRadioButtons = false;
          if (slctAnswer === this.answer){
            this.message = "Congratulations! You figured it out. "
          }else{
            this.message = "Oops!  The time has expired.   " 
          }
          this.message2 = "The picture is: ";
          this.message3 = " Click the 'New Picture' button to visit another place. "
          this.pictureFound = this.pictureName;
          this.onPause();
          this.invisibleArr = this.blankOutAllArr;
          this.setSelectedForImageArr();  
    
          if (this.nbrPictures === this.imageArr.length){
              // onClose call 'setState'
              this.onClose();
          }else{
            this.displayFriend = displayFriendComment(this.props.activityCategory, this.props.friendInfo);
            if (this.displayFriend === true){
                 this.getComment();
            }
            this.setState({callRender: true});
          }
      }else{
        this.message = "Not quite right, please try again."
      } 
  } 

  setSelectedForImageArr(){
      this.nbrPictures += 1;
      for (let i=0; i<this.imageArr.length; i++){
          if (this.imageArr[i].answer === this.answer){
               this.imageArr[i].selected = true;
               break;
          }   
      }
  }

 onClose(){
        if (this.nbrPictures === this.imageArr.length){
            this.displayRadioButtons = false;
            this.message = "Congratulations! You figured it out.  You've had a great time on your vacation! " +
                "You will arrive back at your home in just a little bit."
            this.score.type="finish";
        }else{
            this.score.type="done";
        }
        this.message2 = "The picture is: ";
        this.pictureFound = this.pictureName;
        this.message3 = " ";
        this.score.gamesRemaining = this.imageArr.length - this.nbrPictures;
        this.score.points = 100;
        this.score.maxScore = 100;
        this.score.nbrAttempted = this.nbrPictures;
        this.startButton = false;
        this.setState({finished: true});
        if (this.score.type === "finish"){
            // wait 5 seconds before returning to activity finish
            if(this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.props.onGameOver(this.score);
            }, 5000);
        }else{
            this.props.onGameOver(this.score);
        }
      
  }
  
 getComment(){
      let commentTable = this.props.friendInfo.commentTable;
      let commentObj = determineFriendComment(commentTable, this.commentNbr);
      this.comment = commentObj.comment;
      this.commentNbr = commentObj.commentNbr;
}

getNewPicture(){
    this.arrayCreated = false;
    this.setState({rerender: !this.state.rerender});
}

 render(){
    if (this.state.finished === false){
        if (this.arrayCreated === false){
            this.preProcess();
        }
        this.coverUpCards = this.blankOutAllArr.map((key, index) =>
            <UnderCoverPuzzleCard key={index} index={index} 
                nbrColumns={this.nbrColumns} nbrRows={this.nbrRows}
                totalWidthPx={this.state.totalWidth} totalHeightPx={this.state.totalHeight}
                invisibleArr={this.invisibleArr}/>
            );
        
        if (this.displayRadioButtons === true){
            this.radioButtons = this.imageArr.map((imageList, index) =>
                <UnderCoverRadioButtons key={index} vacationSlct={imageList} 
                correctAnswer={this.correctAnswer}
                onSelect={(slctAnswer) => this.onChangeValue(slctAnswer)}            
                />
            );
        }
    }
    
  return(

    <div>
        <div className="under-cover-puzzle-background" >
            <div  className="under-cover-img" ref={this.imageRef}
                    style={{backgroundImage: `url(${process.env.PUBLIC_URL + this.backgroundURL})`}}>
                {!this.state.finished ?    
                    <div>
                        {this.coverUpCards}
                    </div>
                :
                    null
                }
            </div>
            <div>
                <div className="under-cover-text-position" lang="en">
                    <div>
                    {this.startButton ?
                        <Button id='btn' size="sm" variant="primary" onClick={this.timer} 
                            disabled={this.state.finished}>
                            Start
                        </Button>
                    :
                        <Button id='btn' size="sm" variant="primary" onClick={() => this.getNewPicture()} 
                            disabled={this.state.finished}>
                            New Picture
                        </Button>
                    }
                    
                    <Button className="ml-4" size="sm" variant="primary"  onClick={() => this.onClose()}>
                        Done
                    </Button>
                
                </div>
                <div className={this.textClass}>
                        <div className="font-weight-bold">Number of Places Visited so Far:  {this.nbrPictures}
                            &nbsp;of&nbsp;{this.imageArr.length}</div>
                        Can you guess what is in the picture?
                        {this.displayRadioButtons ?
                            <>
                                {this.radioButtons}
                            </>
                        :
                        <>
                                <div className="mt-2 font-weight-bold">
                                    {this.message}
                                </div>
                                <div>
                                    {this.message2}&nbsp;&nbsp; <b>{this.pictureFound}</b>
                                </div> 
                                <div>
                                    {this.message3} 
                                </div>
                            </>
                        }
                    
                </div>
                {this.displayFriend   ?
                    <div>
                        <div>
                            <img src={this.props.friendInfo.friendImgURL}  
                                className="under-cover-friend-position" 
                                alt="friendPicture"/>
                        </div>
                        <div className="speech-vacation-activity speech-position right">
                                {this.comment}
                        </div>
                    </div>
                    :
                        null
                    }
                </div>
            </div>

      </div>
      {/*
      {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
      */}
    
  </div>              
  )
 }

componentDidMount(){
    this._isMounted = true;
    setTimeout(() => {
        const imageDimensions = getElementDimensions(this.imageRef);
        this.setState({ totalWidth: imageDimensions.width, totalHeight: imageDimensions.height });
    }, 0); // even 0ms is enough to let the modal finish rendering

    // this should help detect when font size is set to 'large' in a browser or display scale
    // set to 150%
    const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const isLargeFont = fontSize >= 20;
    if (isLargeFont) {
        document.documentElement.classList.add('large-font');
    }
    const isZoomed = window.devicePixelRatio >= 1.44;
    if (isZoomed){
        document.documentElement.classList.add("isZoomed");
    }
}
    
 
 componentWillUnmount(){
    this._isMounted = false;
 }
 
}
export default UnderCoverPuzzleModal;

